import React, { useContext, useEffect, useState } from "react";
import { ReactComponent as Portfolio } from "../../Image/assets/portfolioManagement.svg";
import { ReactComponent as Winsight } from "../../Image/assets/winsight.svg";
import { ReactComponent as Customers } from "../../Image/assets/customerNew.svg";
import { ReactComponent as Filters } from "../../Image/assets/filterManagement.svg";
import { ReactComponent as StockListing } from "../../Image/assets/stock lisiting.svg";
import { ReactComponent as RequestManager } from "../../Image/assets/request manager.svg";
import { ReactComponent as RightArrow } from "../../Image/assets/rightArrow.svg";
import { ReactComponent as LeftArrow } from "../../Image/assets/leftArrow.svg";
import { ReactComponent as Logout } from "../../Image/assets/Logout.svg";
import { ReactComponent as Etf } from "../../Image/assets/ETF.svg";
import { ReactComponent as DocumentManager } from "../../Image/assets/Document Mangt.svg";
import { ReactComponent as Sector } from "../../Image/assets/sector.svg";
import { ReactComponent as MoreIcon } from "../../Image/assets/more.svg";
import { ReactComponent as FailedIcon } from "../../Image/assets/transaction-failed.svg";
import { ReactComponent as BondAnalysis } from "../../Image/assets/BondAnalysis.svg";
import { ReactComponent as BondsAnalyzer } from "../../Image/assets/Bonds.svg";
import { ReactComponent as RebalanceOrders } from "../../Image/assets/Rebalance-order.svg";
import { ReactComponent as StockSymbol } from "../../Image/assets/StockSymbol.svg";
import { ReactComponent as Report } from "../../Image/assets/Report.svg";
import { ReactComponent as BuySell } from "../../Image/assets/Report.svg";
import { ReactComponent as StockSplit } from "../../Image/assets/StockSplit.svg";
import { ReactComponent as CorporateAction } from '../../Image/assets/corporate.svg';
import { ReactComponent as Billing } from '../../Image/assets/Billing.svg';
import { ReactComponent as Email } from '../../Image/assets/Email.svg';
import { ReactComponent as IpoStocks } from '../../Image/assets/IpoStocks.svg'
import {ReactComponent as SectorTechnical} from '../../Image/assets/sectorTechnical.svg';
// import {ReactComponent as Zeroda} from '../../Image/assets/Zeroda.svg';
import styles from "./portfolio.module.scss";
import "./addPortfolioModal.css";
import { Button, Drawer, Layout, Menu, Tooltip } from "antd";
import { Routes, useLocation, useNavigate } from "react-router-dom";
import { MoreOutlined, MenuOutlined } from "@ant-design/icons";
import AuthContext from "../../AuthContext";
import Cookies from "js-cookie";

// import StockSplit from "../Stock Splitting/StockSplit";
// import BondAnalysis from "../Bond Analysis/BondAnalysis";

const { Header, Content, Footer, Sider } = Layout;

function PortfolioLayout(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState("1");
  const [collapsed, setCollapsed] = useState(true);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);

  const { setNewReq } = useContext(AuthContext);

  function getItem(label, key, icon, href) {
    return {
      key,
      icon,
      label: (
        <a
          href={href}
          target="_blank" // Allows opening in a new tab when right-clicked
          rel="noopener noreferrer"
          onClick={(e) => {
            e.preventDefault(); // Prevent default navigation
            navigate(href); // Use React Router for navigation
          }}
          style={{
            textDecoration: "none",
            color: "inherit",
            width: "100%",
            display: "block",
          }}
        >
          {label}
        </a>
      ),
    };
  }

  useEffect(() => {
    // Sync the selectedKey based on the current location path
    switch (location.pathname) {
      case "/customers":
        setSelectedKey("1");
        break;
      case "/stock-analyser":
        setSelectedKey("2");
        break;
      case "/portfolio-management":
        setSelectedKey("4");
        break;
      case "/model-portfolio-details":
        setSelectedKey("4");
        break;
      case "/model-portfolio-history":
        setSelectedKey("4");
        break;
      case "/etf-list":
        setSelectedKey("3");
        break;
      case "/filter-management":
        setSelectedKey("5");
        break;
      case "/create-filter-management":
        setSelectedKey("5");
        break;
      case "/edited-filter-management-history":
        setSelectedKey("5");
        break;
      case "/request-manager":
        setSelectedKey("6");
        break;
      case "/request-manager/initiate-transaction":
        setSelectedKey("6");
        break;
      case "/request-manager/bulk-transaction":
        setSelectedKey("6");
        break;
      case "/document-manager":
        setSelectedKey("7");
        break;
      case "/attach-doc":
        setSelectedKey("8");
        break;
      case "/sector-management":
        setSelectedKey("9");
        break;
          case "/sector-technical":
        setSelectedKey("10");
        break;
      case "/failed-orders":
        setSelectedKey("11");
        break;
      // case "/bond-analysis":
      //   setSelectedKey("12");
      //   break;
      // case "/bond-data":
      //   setSelectedKey("12");
      //   break;
      case "/stock-symbol":
        setSelectedKey("13");
        break;
      case "/symbol-category":
        setSelectedKey("15");
        break;
      case "/rebalance":
        setSelectedKey("14");
        break;
      // case "/reports":
      //   setSelectedKey("16");
      //   break;
      case "/stock-split":
        setSelectedKey("17");
        break;
      case "/corporate-action":
        setSelectedKey("18");
        break;
      case "/billing":
        setSelectedKey("19");
        break;
      case "/email":
        setSelectedKey("20");
        break;
      case "/email-history":
        setSelectedKey("20");
        break;
      case "/ipo-stock":
        setSelectedKey("21");
        break;
case "/bought-sold":
        setSelectedKey("22");
        break;
      // case "/bond-analysis/bond-analysis":
      //   setSelectedKey("12");
      //   break;

      // case "/bond-analysis/bond-data":
      //   setSelectedKey("13");
      //   break;
      // case "/initiate-adhoc-transaction":
      //   setSelectedKey("6");
      //   break;
      default:
        setSelectedKey("1"); // Default key
    }
  }, [location.pathname]);

  const items = [
    getItem("Customers", "1", <Customers />, "/customers"),
    getItem("Stock Listing", "2", <StockListing />, "/stock-analyser"),
    getItem("Etf", "3", <Etf />, "/etf-list"),
    getItem(
      "Model Portfolio",
      "4",
      <Portfolio />,
      "/portfolio-management"
    ),
    getItem("Sector Management", "9", <Sector />, "/sector-management"),
    getItem("Sector Technicals", "10", <SectorTechnical />, "/sector-technical"),
    getItem("Filter Management", "5", <Filters />, "/filter-management"),
    getItem("More", "99", <MoreIcon />, ""),
  ];

  const more = items.slice(7, 7);
  const moreItems = [
    getItem("Request Manager", "6", <RequestManager />, "/request-manager"),
    getItem("Failed Orders", "11", <FailedIcon />, "/failed-orders"),
    getItem("Document Manager", "7", <DocumentManager />, "/document-manager"),
    // getItem("Bond Analysis", "12", <BondAnalysis />, "/bond-analysis"),
    getItem("Stock Category", "13", <StockSymbol />, "/stock-symbol"),

    getItem("Symbol Category", "15", <BondsAnalyzer />, "/symbol-category"),
    getItem("Rebalance", "14", <RebalanceOrders />, "/rebalance"),
    // getItem("Reports", "16", <Report />, "/reports"),
    getItem("Reports", "22", <BuySell />, "/bought-sold"),
    getItem("Stock Split & Bonus", "17", <StockSplit />, "/stock-split"),
    getItem("Corporate Action", "18", <CorporateAction />, "/corporate-action"),
    getItem("Invoice", "19", <Billing />, "/billing"),
    getItem("Email", "20", <Email />, "/email"),
    getItem("Ipo Stocks", "21", <IpoStocks />, "/ipo-stock")
  ];

  const handleMenuClick = (e) => {
    if (e.key === "99") {
      setIsDrawerVisible(true);
      return;
    }
    setSelectedKey(e.key);

    switch (e.key) {
      case "1":
        navigate("/customers");
        break;
      case "2":
        navigate("/stock-analyser");
        break;
      case "4":
        navigate("/portfolio-management");
        break;
      case "3":
        navigate("/etf-list");
        break;
      case "5":
        navigate("/filter-management");
        break;
      case "6":
        navigate("/request-manager");
        setNewReq({ view: null, show: false });
        break;
      case "7":
        navigate("/document-manager");
        break;
      case "8":
        navigate("/attach-doc");
        break;
      case "10":
          navigate("/sector-technical");
        break;
      case "9":
        navigate("/sector-management");
        break;
      case "11":
        navigate("/failed-orders");
        break;
      case "12":
        navigate("/bond-analysis");
        break;
      case "15":
        navigate("/symbol-category");
        break;
      case "14":
        navigate("/rebalance");
        break;
      case "13":
        navigate("/stock-symbol");
        break;
      // case "16":
      //   navigate("/reports");
      //   break;
      case "17":
        navigate("/stock-split");
        break;
      case "18":
        navigate("/corporate-action")
        break;
      case "19":
        navigate("/billing")
        break;
      case "20":
        navigate("/email")
        break;
      case "21":
        navigate("/ipo-stock")
        break;
          case "22":
        navigate("/bought-sold")
        break;
      default:
        navigate("/customers");
    }
    setCollapsed(true);

    setIsDrawerVisible(false);
  };

  const deleteCookie = (name) => {
    document.cookie = name + "=; Max-Age=0; path=/;"; // Set cookie expiry to past date to delete
  };

  const handleLogout = () => {
    // Delete the AccessToken cookie
    Cookies.remove("AccessToken", { path: "/" });
    Cookies.remove("RefreshToken", { path: "/" });

    // Navigate to the homepage

    navigate("/");
  };

  return (
    <Layout className={styles.Portfolio_layout}>
      <Sider
        className={collapsed ? "sidebar" : "sidebar1"}
        collapsible
        collapsed={collapsed}
        trigger={null}
        width={240}
      >
        <div className="demo-logo-vertical" />
        <div
          className={styles.portfolio_logo}
          onClick={() => setCollapsed(!collapsed)}
        >
          <Winsight className={styles.winsightLogo} />
          {!collapsed && <p className={styles.winsightLetter}>Winwize</p>}
        </div>

        <Menu
          //   theme="dark"
          mode="inline"
          selectedKeys={selectedKey}
          onClick={(e) => handleMenuClick(e)}
          // items={items}
          className={!collapsed ? "menuItems" : "collapseItems"}
        >
          {items.map((item) => (
            <Menu.Item key={item.key} icon={item.icon} style={{ color: "white" }}>
              {item.label}
            </Menu.Item>
          ))}
          {more.map((item) => (
            <Menu.Item
              key={item.key}
              icon={item.icon}
              onClick={(e) => handleMenuClick(e)}
              style={{ color: "white" }}
            >
              {item.label}
              {/* <Button
                type="text"
                icon={<MenuOutlined />}
                style={{ color: "white", width: "100%", textAlign: "left" }}
                onClick={(e) => handleMenuClick(e)}
              >
                More
                <DownOutlined />
              </Button> */}
            </Menu.Item>
          ))}
        </Menu>
        <div className={styles.footerIcons}>
          <Button
            type="text"
            icon={collapsed ? <RightArrow /> : <LeftArrow />}
            onClick={() => setCollapsed(!collapsed)}
            style={!collapsed ? { paddingLeft: "5px" } : { paddingLeft: "3px" }}
            className="logoutButton"
          >
            {!collapsed ? "Collapse Sidebar" : ""}
          </Button>
          <Button
            type="text"
            icon={<Logout />}
            onClick={handleLogout}
            className="logoutButton"
            style={{ paddingLeft: "3px" }}
          >
            {!collapsed ? "Logout" : ""}
          </Button>
        </div>
      </Sider>
      <Drawer
        // title="More Options"
        placement="left"
        closable={false}
        onClose={() => setIsDrawerVisible(false)}
        open={isDrawerVisible}
        style={
          collapsed
            ? { position: "relative", left: "60px", maxWidth: "60px" }
            : { position: "relative", left: "240px", maxWidth: "240px" }
        }
        // destroyOnClose
        className={collapsed ? "sidebar_drawer" : "sideBar_uncollapsed"}
      >
        <Menu
          mode="inline"
          selectedKeys={selectedKey}
          onClick={(e) => handleMenuClick(e)}
          className={!collapsed ? "menuItems" : "collapseItems"}
          style={{ paddingLeft: "7px" }}
        >
          {moreItems.map((item) => (
            <Menu.Item
              key={item.key}
              icon={item.icon}
              style={{ paddingLeft: "11px", color: "white" }}
            >
              <Tooltip title={item.label.props.children} placement="right">
                {item.label}
              </Tooltip>
            </Menu.Item>
          ))}
        </Menu>
      </Drawer>
      <Layout className={styles.container}>
        {/* <Header
          style={{
            padding: 0,
            background: "#FCFCFC",
            // background: colorBgContainer,
          }}
        /> */}
        <Content className={styles.content}>
          {props?.main}
          {/* {selectedKey === "1" && <div>cosutomer</div>}
          {selectedKey === "2" && <div>Sotck</div>}
          {selectedKey === "3" && props?.main}
          {selectedKey === "4" && <div>strategy</div>}
          {selectedKey === "5" && <div>filter</div>} */}
        </Content>
        {/* <Footer> */}
        {/* <p className={styles.footer_text}>Powered By Hutech Solutions</p> */}
        {/* </Footer> */}
      </Layout>
    </Layout>
  );
}

export default PortfolioLayout;